import React from "react";
import LocationListItem from "../../components/location/LocationList/LocationListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const LocationListPage = ()  => {

    useTitle(t`List Location`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <LocationListItem showAdd={true} {...query} />
        </Box>
    )
}

export default LocationListPage;
